import toPath from './toPath'

function setInRecursor(current, idx, path, value) {
	if (idx >= path.length) {
		// end of recursion
		return value
	}
	const key = path[idx]

	if (isNaN(key)) {
		// object set
		if (current === undefined || current === null) {
			const result = setInRecursor(undefined, idx + 1, path, value)
			return result === undefined ? undefined : { [key]: result }
		}
		if (Array.isArray(current)) {
			throw new Error('@insight/toolkit-utils: setInObject() cannot set a non-numeric property on an array')
		}

		// Current exists, so copy all of its value and add/update the new one
		const result = setInRecursor(current[key], idx + 1, path, value)
		const numKeys = Object.keys(current).length
		if (result === undefined) {
			if (current[key] === undefined && numKeys === 0) {
				// object was empty
				return undefined
			}
			if (current[key] !== undefined && numKeys <= 1) {
				// only key we had was the one we are deleting
				if (!isNaN(path[idx - 1])) {
					// we are in an array so return an empty object
					return {}
				} else {
					return undefined
				}
			}
		}

		// set result..
		return { ...current, [key]: result }
	}

	// array set
	const numericKey = Number(key)
	if (current === undefined || current === null) {
		const result = setInRecursor(undefined, idx + 1, path, value)
		if (result === undefined) {
			return undefined
		}

		const arr = []
		arr[numericKey] = result
		return arr
	}

	if (!Array.isArray(current)) {
		throw new Error('@insight/toolkit-utils: setInObject() cannot set a numeric property on an object')
	}

	const existingValue = current[numericKey]
	const result = setInRecursor(existingValue, idx + 1, path, value)

	const arr = [...current]
	arr[numericKey] = result
	return arr
}


export default function setInObject(state, key, value) {
	if (state === undefined || state === null) {
		throw new Error(`toolkit-utils: setInObject() cannot be called with ${String(state)} object state`)
	}
	if (key === undefined || key === null) {
		throw new Error(`toolkit-utils: setInObject() cannot be called with ${String(key)} key`)
	}

	// Recursive function needs to accept and return state, but public API should only
	// deal with objects
	return setInRecursor(state, 0, toPath(key), value)
}
